const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;

export const getImageUrl = (imageKey) => {
  if (!imageKey) return null;
  if (imageKey.startsWith("http") || imageKey.startsWith("data:"))
    return imageKey;
  return `${S3_BASE_URL}/${imageKey}`;
};

export const generateId = () =>
  `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

export const DEFAULT_SETTINGS = {
  backgroundColor: "#ffffff",
  accentColor: "#1E4FCF",
  showPrices: true,
  showImages: true,
  summaryEnabled: true,
  allowBackNavigation: true,
  layoutTemplate: "dark",
  panelPosition: "right",
  optionsLayout: "list",
  imageDisplay: "contain",
  showThumbnails: true,
  checkoutOptions: {
    saveConfiguration: true,
    directPayment: false,
    mollieProfileId: "",
  },
};

export const LAYOUT_TEMPLATES = [
  {
    value: "dark",
    label: "Donker",
    description: "Donkere achtergrond, lichte tekst — premium look",
  },
  {
    value: "light",
    label: "Licht",
    description: "Lichte achtergrond, donkere tekst — clean & modern",
  },
  {
    value: "minimal",
    label: "Minimaal",
    description: "Strak & minimalistisch met subtiele accenten",
  },
];

export const STEP_TYPES = [
  {
    value: "select",
    label: "Selectie",
    description: "Kies één optie uit een lijst",
  },
  {
    value: "color",
    label: "Kleur",
    description: "Kleur selectie met visuele swatches",
  },
  {
    value: "size",
    label: "Maat",
    description: "Maat/dimensie selectie",
  },
  {
    value: "visual",
    label: "Visueel",
    description: "Grote kaarten met afbeeldingen",
  },
  {
    value: "checkbox",
    label: "Checkbox",
    description: "Meerdere opties aan/uit vinken",
  },
  {
    value: "frame-color",
    label: "Frame Kleur",
    description: "SVG zones of afbeelding met kleur tinting",
  },
];

export const MAX_ZONES = 10;
